import { SVGProps } from 'react';

import { styleConfigs } from '../../resources/styleConfigs';

const HomeIcon = ({
  width = styleConfigs.dimensions.width24,
  height = styleConfigs.dimensions.height24,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.753 13.9443V22.1943H9.753V16.1943C9.753 15.3659 10.4246 14.6943 11.253 14.6943H12.753C13.5814 14.6943 14.253 15.3659 14.253 16.1943V22.1943H20.253V13.9443"
      stroke="#637381"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.752998 12.4441L10.942 2.25511C11.2233 1.9736 11.605 1.81543 12.003 1.81543C12.401 1.81543 12.7827 1.9736 13.064 2.25511L23.253 12.4441"
      stroke="#637381"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HomeIcon;
